import React from 'react';

class Event extends React.Component {
	constructor(props) {
		super(props);
	}

  componentDidMount() {
  }

	render() {
		let {
			title, 
			event
		} = this.props;
	
		let startTime = event.lStartTime.split(" ")[1];
		let endTime = event.lEndTime.split(" ")[1];
		return (
			<div className='classtop-event-content'>
				<div>
					{title}
				</div>
				<div>
					{startTime} - {endTime}
				</div>
				<div>
					{event.state}
				</div>
			</div>
		);
	}
}

export default Event



// WEBPACK FOOTER //
// ./src/template/ClassCalendar/Event.js